import { createGlobalStyle } from "styled-components";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const FontStyles = createGlobalStyle`
@font-face {
  font-family: "MTNBold";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-Bold.otf") format("opentype");
}
@font-face {
  font-family: "MTNBoldItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-BoldItalic.otf") format("opentype");
}
@font-face {
  font-family: "MTNExtraBold";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-ExtraBold.otf") format("opentype");
}
@font-face {
  font-family: "MTNExtraBoldItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-ExtraBoldItalic.otf") format("opentype");
}
@font-face {
  font-family: "MTNExtraLight";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-ExtraLight.otf") format("opentype");
}
@font-face {
  font-family: "MTNExtraLightItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-ExtraLightItalic.otf") format("opentype");
}
@font-face {
  font-family: "MTNLight";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-Light.otf") format("opentype");
}
@font-face {
  font-family: "MTNLightItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-LightItalic.otf") format("opentype");
}
@font-face {
  font-family: "MTNMedium";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-Medium.otf") format("opentype");
}
@font-face {
  font-family: "MTNMediumItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-MediumItalic.otf") format("opentype");
}
@font-face {
  font-family: "MTNRegular";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-Regular.otf") format("opentype");
}
@font-face {
  font-family: "MTNRegularItalic";
  src: url("${SERVER_URL}/fonts/MTNBrighterSans-RegularItalic.otf") format("opentype");
}
@font-face {
  font-family: 'Digital Numbers Regular';
  font-style: normal;
  font-weight: normal;
  src: url('${SERVER_URL}/fonts/DigitalNumbers-Regular.woff') format('woff');
}
`;

export default FontStyles;
